import {
  createContext,
  RefObject,
  ReactNode,
} from 'react';

type Part = 'header' | 'actions';

export type Entity = Record<string, any> & {
  id: number | string;
};

export type SidePanelComponentProps<E = Entity> = {
  entity: E;
  onClose?: () => void;
  extensionRef?: RefObject<HTMLDivElement>;
  slots?: Partial<Record<Part, ReactNode>>;
};

export type ActivePanel = {
  type: string;
  panelInfo: unknown;
  entityKey: string;
};

export type OpenPanelOptions = {
  canGoBack?: boolean;
  previousPanelInfo?: unknown;
};

type ContextValues = {
  activePanel: ActivePanel | null;
  // TODO: Derive from the registry so each panel type requires its own panelInfo
  openPanel: (type: string, panelInfo: unknown, options?: OpenPanelOptions) => void;
  closePanel: () => void;
  goBack: () => void;
};

export const SidePanelContext = createContext<ContextValues>({
  activePanel: null,
  openPanel: () => {},
  closePanel: () => {},
  goBack: () => {},
});

// What a linkable panel's own state hooks need to know about it
export type PanelInstance = {
  params: readonly string[];
  // The search the panel was shown with, kept while it slides out
  search: string;
  // Queues an update that only applies while the URL still shows this panel
  queueUrlParamsUpdate: (update: (searchParams: URLSearchParams) => void) => void;
};

// Null outside a linkable panel
export const PanelInstanceContext = createContext<PanelInstance | null>(null);
